import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://xhcfrdzsbqhavswbjphm.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhoY2ZyZHpzYnFoYXZzd2JqcGhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM3MjMxNjAsImV4cCI6MjA3OTI5OTE2MH0.MKy8bhwS42GVUXcGPEmcG5cn9h2n4MJF3kSP-8t5lNs';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
        storageKey: 'trouvetonvie-auth'
    }
});

